<template>
	<div class="answer-list">
		<div class="card">
			<div class="card-body detail-box">
				<div class="mb-3">
					<span class="titles"> {{ visits.outlet.name }}</span>
				</div>
				<div class="dash-card">
					<span class="details">ادرس مشتری:{{ visits.outlet.address }}</span>
					<span class="details">کد مشتری:{{ visits.outlet.code }}</span>
					<span class="details">شهر مشتری:{{ visits.outlet.city.name }}</span>
					<span class="details">نوبت ویزیت:{{ visits.visit_turn }}</span>
					<span class="details"
						>زمان شروع ویزیت:
						<date-picker
							v-model="visits.start_datetime"
							type="datetime"
							format="YYYY-MM-DD HH:mm"
							display-format="jYYYY-jMM-jDD HH:mm"
							:timezone="true"
							:disabled="true"
						/>
					</span>
					<hr class="solid" />
					<div>
						<p>بازخورد</p>
						<span>کاربر: {{ modalName }} {{ modalLastName }}</span>
						<b-form-textarea
							id="textarea"
							v-model="commentData.visit_comment"
							placeholder=""
							rows="3"
							max-rows="6"
							class="mt-2"
							style="border-radius: 4px"
						></b-form-textarea>
						<div class="d-flex flex-row justify-content-end w-100 mt-3">
							<button @click="acceptComment" class="accept-modal">ذخیره</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-for="list in catList" :key="'cat' + list.id" class="card mt-4">
			<div class="card-body">
				<div class="mb-3">
					<span class="answers-title"> {{ list.verbose_name }} </span>
				</div>
				<div class="d-flex justify-content-between">
					<div class="flex-column w-50">
						<div class="mb-4" v-for="answers in answerList" :key="answers.id">
							<div v-if="list.id === answers.question.report_category.id">
								<p class="mb-2">{{ answers.question.text }}</p>
								<p class="short_text">{{ answers.question.short_text }}</p>
								<div v-for="answerType in answers.question.answer_type" :key="answerType.id">
									<div v-if="answerType.name === 'YesNo'">
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
										</div>
									</div>
									<div v-if="answerType.name === 'Triple'">
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
											<span class="answers-box" v-if="answers.bool === null"> ندارد</span>
										</div>
									</div>
									<div v-if="answerType.name === 'Score'">
										<div class="box">
											<span class="persian-number" v-if="answers.score === 1">1</span>
											<span class="persian-number" v-if="answers.score === 2">2</span>
											<span class="persian-number" v-if="answers.score === 3">3</span>
											<span class="persian-number" v-if="answers.score === 4">4</span>
											<span class="persian-number" v-if="answers.score === 5">5</span>
										</div>
									</div>
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'Input'"
									>
										<div class="box">
											<span class="answers-box">{{ answers.text }}</span>
										</div>
									</div>
									<div v-if="answerType.name === 'RadioChoice'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.radio.answer }}</span>
											</div>
										</div>
									</div>
									<div v-if="answerType.name === 'DropDownList'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.dropdown.answer }}</span>
											</div>
										</div>
									</div>
									<div class="d-flex align-items-center" v-if="answerType.name === 'Description'">
										<textarea
											:disabled="true"
											v-model="answers.description"
											rows="4"
											cols="50"
											class="mt-4"
											style="border-radius: 4px"
										>
										</textarea>
									</div>
									<!-- <div v-if="answerType.name === 'Description'">
										<textarea
											:disabled="true"
											v-model="answers.description"
											rows="4"
											cols="50"
											class="mt-4"
											style="border-radius: 4px"
										>
										</textarea>
									</div> -->
									<div class="d-flex" v-if="answerType.name === 'Multichoice'">
										<div
											v-for="multiAnswers in answers.multichoice"
											:key="multiAnswers.id"
											class="box"
										>
											<span class="answers-box"> {{ multiAnswers.answer }} </span>
										</div>
									</div>
									<div class="d-flex aling-item-center" v-if="answerType.name === 'Number'">
										<span class="short-text">{{ answers.question.short_text }} :</span>
										<div class="box">
											<span class="answers-box"> {{ answers.number }} </span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex">
						<div v-for="(image, index) in images" class="ml-3" :key="image.id">
							<div v-if="list.id === image.type.report_category.id">
								<img @click="callModalimage(index)" class="answers-images" :src="image.link" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Tableview
			:hover="true"
			:bordered="true"
			class="mt-4 pb-4"
			:showNoContent="showContnetFunc"
			:showNoData="showDataFunc"
		>
			<template #TableTitle>
				<tr>
					<th>ردیف</th>
					<th>عنوان</th>
					<th>تصویر</th>
					<th>تاریخ</th>
					<th>لوکیشن</th>
				</tr>
			</template>

			<template #TableBody>
				<tr v-for="(item, index) in images" :key="item.id">
					<td class="persian-number">
						{{ 1 + index }}
					</td>
					<td>{{ item.type.verbose_name }}</td>
					<td>
						<img @click="callModalimage(index)" class="images" :src="item.link" />
					</td>
					<td>
						<date-picker
							v-model="item.datetime_created"
							type="datetime"
							format="YYYY-MM-DD HH:mm"
							display-format="jYYYY-jMM-jDD HH:mm"
							:timezone="true"
							:disabled="true"
						/>
					</td>
					<td>
						<span class="location" @click="showLocation(item)">مشاهده</span>
					</td>
				</tr>
			</template>
		</Tableview>
		<b-modal hide-footer hide-header size="lg" centered v-model="imageModal">
			<b-carousel
					id="carousel-fade"
					style="text-shadow: 1px 1px 2px #333"
					v-if="images.length"
					controls
					indicators
					background="#ababab"
					fade
					v-model="carouselIndex"
					interval="120000"
				>
					<b-carousel-slide
						v-for="(image, index) in images"
						:key="index"
						:img-src="image.link"
					></b-carousel-slide>
				</b-carousel>
			<!-- <img class="modal-img" :src="imageUrl" /> -->
		</b-modal>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';

export default {
	components: {
		Tableview,
	},
	data() {
		return {
			answerList: [],
			catList: [],
			visits: {},
			images: 0,
			imageModal: false,
			rejectReason: null,
			imageUrl: null,
			commentData: {},
			modalName: '',
			modalLastName: '',
			carouselIndex:0

		};
	},
	mounted() {
		this.getAnswerList();
		this.getImageList();
		this.getCategoryList();
		this.comment();
		this.getVisitDetails();
	},
	computed: {
		reasonBtn() {
			if (this.rejectReason === null || this.rejectReason.length === 0) {
				return true;
			} else {
				return false;
			}
		},
		showContnetFunc() {
			return this.images === 0;
		},
		showDataFunc() {
			if (this.images.length !== undefined) {
				return this.images.length === 0;
			}
			return false;
		},
	},
	methods: {
		async getVisitDetails() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_DETAIL_EDIT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visits = res.data;
			}
		},
		async getCategoryList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.REPORT_CAT_LIST +
					'?visit_id=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_for_supervision=' +
					true,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.catList = res.data;
			}
		},
		callModalimage(index) {
			this.imageModal = true;
			this.carouselIndex = index;

			// this.imageUrl = item.link;
		},

		async getAnswerList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_VISIT_ANSWER_LIST +
					'?visit=' +
					lastParam +
					'&ordering=question__priority' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&question__question_type__is_for_supervision=' +
					true +
					'&question__question_type__is_active=' +
					true,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.answerList = res.data;
				this.questions = res.data.question;
			}
		},
		async comment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.commentData = res.data;
				this.modalName = res.data.comment_publisher.first_name;
				this.modalLastName = res.data.comment_publisher.last_name;
			}
		},
		async acceptComment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.put(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{
					visit_comment: this.commentData.visit_comment,
				},
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'بازخورد با موفقیت تغییر کرد!',
				});
			}
		},
		async getImageList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PHOTO_LIST +
					'?visit=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&type__is_for_supervision=' +
					true,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.images = res.data;
				'images:', res.data;
			}
		},
		showLocation(item) {
			window.open(`https://maps.google.com/?q=${item.latitude},${item.longitude}`, '_blank');
		},
	},
};
</script>
<style lang="scss" scoped>
.answer-list {
	padding: 24px;
	.detail-box {
		padding: 14px 24px;
		.titles {
			font-size: 18px;
		}
	}
	.dash-card {
		border: 1px dashed #c4c4c4;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 50px;
		border-radius: 8px;
	}
	.details {
		display: flex;
		align-items: center;
		font-size: 14px;
		margin-top: 8px;
		font-family: 'IRANYekanfa' !important;
		&:last-child {
			flex-direction: row;
			align-items: center;
			margin-top: 0;
		}
	}
	.box {
		background: #d9d9d9;
		border-radius: 8px;
		padding: 10px;
		width: 72px;
		display: flex;
		justify-content: center;
		border-radius: 8px;

		.answers-box {
			font-size: 14px;
			color: #616162;
		}
		.persian-number {
			font-family: 'IRANYekanfa' !important;
			font-size: 14px;
			color: #616162;
		}
	}
	.images {
		max-width: 60px;
		border-radius: 8px;
	}
	.location {
		color: #007bff !important;
		cursor: pointer;
	}
}
.btns {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 15px;
	.accept {
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		padding: 8px 40px;
		border: none !important;
		margin-left: 10px;
		border-radius: 8px;
	}
	.accept:disabled {
		background: #c4c4c4;
	}
	.reject {
		border: 1px solid #2d8b8b !important;
		border-radius: 8px;
		padding: 8px 40px;
		background: #fff;
		border-radius: 8px;
	}
}
.modal-img {
	width: 100%;
}
.text-area {
	width: 100%;
	border: 1px solid #c4c4c4;
	border-radius: 8px;
	margin-bottom: 16px;
	padding: 4px;
	border-radius: 8px;
}
.short-text {
	font-weight: bold;
	margin-left: 10px;
}
.persian-number {
	font-family: 'IRANYekanfa' !important;
}
.answers-title {
	font-size: 18px;
	font-weight: 700;
}
.answers-images {
	max-width: 120px;
}
.accept-modal {
	height: 38px;
	background: #2d8b8b;
	border-radius: 8px;
	color: #fff;
	border: none !important;
	margin-left: 10px;
	min-width: 100px;
	border-radius: 8px;
}
.card {
	border: none !important;
	border-radius: 8px !important;
}
.short_text {
	color: #c4c4c4;
	font-size: 16px;
}
</style>

<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
